export default __webpack_public_path__ + "static/media/blessedconquest.2a9c655d.png";